import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";
import { ToastType } from "../enums/global-enums";

@Injectable({
  providedIn: "root",
})
export class LoveItToastService {
  constructor(private toastController: ToastController) {}

  showToastMessage(message: string, type: ToastType = ToastType.Info, errorCode?: number) {
    const isInfo = type === ToastType.Info;
    const toastPromise = this.toastController.create({
      message: `${message}`,
      duration: isInfo ? 3000 : 0,
      cssClass: isInfo ? "info-toast" : "interactive-toast",
      buttons: isInfo
        ? []
        : [
            {
              icon: "close",
              role: "cancel",
            },
          ],
    });

    toastPromise.then((toast) => {
      toast.present();
    });
  }
}
